import { ObjectMapper } from 'json-object-mapper';
import { IModel } from '../IModel';
import { Model } from '../model';
import { SystemModuleType } from 'services/enums/SystemModuleType.enum';

export class ActionRequiredModel extends Model implements IModel<ActionRequiredModel> {
  companyId: string = '';
  costCenterId: string = '';
  companyGroupId: string = '';
  source: string = '';
  type: number = 0;
  title: string = '';
  description: string = '';
  employeeIds: string[] = [];
  referenceId: string = '';
  accessProfilesIds: string[] = [];
  hierarchyLevelIds: string[] = [];
  status: string = 'PENDING';
  getUrl: string = '';

  get sourceData(): SystemModuleType {
    return SystemModuleType.getBy(this.source) as SystemModuleType;
  }

  static create(input: any): ActionRequiredModel {
    return ObjectMapper.deserialize<ActionRequiredModel>(ActionRequiredModel, input);
  }
}
